<template>
  <section class="dropdowns">
    <section-title>Dropdowns Component</section-title>
    <form-wrap>
      <form-field-set>
        <dropdown-input
          :options="options"
          position="left"
          @select="handleSelect"
        >
          <button-input>
            Open Dropdown
          </button-input>
        </dropdown-input>

        <pre v-if="selected">Selected: {{ selected.label }}</pre>
      </form-field-set>
    </form-wrap>
  </section>
</template>

<script>
import PlaygroundCommmonMixin from '@/mixins/pages/playground/PlaygroundCommon'
import FormFieldSet from '@/components/forms/FormFieldSet'
import FormWrap from '@/components/forms/FormWrap'
import SectionTitle from '@/components/ui/SectionTitle'
import FormMixin from '@/mixins/forms/Form'

export default {
  name: 'Dropdowns',
  mixins: [PlaygroundCommmonMixin, FormMixin],
  components: {
    FormFieldSet,
    FormWrap,
    SectionTitle
  },
  data () {
    return {
      selected: null
    }
  },
  computed: {
    options () {
      return [
        { label: 'Spiderman', value: 'spiderman', icon: 'bell' },
        { label: 'Hulk', value: 'hulk', icon: 'circle' },
        { label: 'Superman', value: 'superman', icon: 'clipboard' }
      ]
    }
  },
  methods: {
    handleSelect (selected) {
      this.selected = selected
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/playground/Dropdowns.vue